import React from 'react';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _has from 'lodash/has';
import _map from 'lodash/map';
import Draggable from 'react-draggable';
import PropTypes from 'prop-types';
// Material UI
import MuiDialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiIconButton from '@material-ui/core/IconButton';
import MuiPaper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
// Core components
import { TextButton, ContainedButton } from 'components/core/Button';
import Typography from 'components/core/Typography';
// HOCS
import withConfirmDialog from 'hocs/WithConfirmDialog';
// Custom
import { dialogShape } from 'constants/PropTypesShapes';
import { WarningContainedButton } from 'components/buttons/ContainedButtons';
import AppIcon from 'components/icons/AppIcon';

// Dialog components
// Global
import ConfirmMessage from 'components/dialogs/ConfirmMessage';
import InfoMessage from 'components/dialogs/InfoMessage';
import PlanningPeriodEditForm from 'components/plannings/PlanningPeriodEditForm';
/// Acount
import PasswordConfirmationDialog from 'account/components/PasswordConfirmationDialog';
// Installations
import InstallationEntityAddEditForm from 'installations/assets/entities/EntityAddEditForm';
import InstallationDeviceEditForm from 'installations/assets/configuration/DeviceEditForm';
import InstallationAntipassbackDetails from 'installations/assets/antipassbacks/AntipassbackDetails';
import InstallationDailyCodesAddForm from 'installations/assets/customers/DailyCodesAddForm';
import InstallationLogInfo from 'installations/assets/logs/LogInfo';
import InstallationAsyncOperationHistory from 'installations/assets/asyncOperations/AsyncOperationHistory';
// Devices
import DeviceSmsHistory from 'devices/assets/main/DeviceSmsHistory';
import DeviceLogInfo from 'devices/assets/logs/LogInfo';
// Simcards
import SimcardGroupsManager from 'simcards/assets/groups/GroupsManager';
// Companies
import CompanyChooseList from 'companies/assets/main/CompanyChooseList';
// Profiles
import ProfilePermissions from 'profiles/assets/main/ProfilePermissions';
// User
import UserPermissions from 'users/assets/main/UserPermissions';
import UserPermissionAdd from 'users/assets/main/UserPermissionAdd';
// Carparks
import CarparkContactEditForm from 'cpmCarparks/assets/main/CarparkContactEditForm';
import CarparkSpacesSettingsEditForm from 'cpmCarparks/assets/main/CarparkSpacesSettingsEditForm';
import CarparkDevices from 'cpmCarparks/assets/main/CarparkDevices';
import CarparkPlanningAddEditForm from 'cpmCarparks/assets/plannings/PlanningAddEditForm';
import CarparkPlanningInfo from 'cpmCarparks/assets/plannings/PlanningInfo';
import CarparkParkingCategoryAddEditForm from 'cpmCarparks/assets/parkingCategories/ParkingCategoryAddEditForm';
import CarparkParkingCategoryAddPriceGridForm from 'cpmCarparks/assets/parkingCategories/ParkingCategoryAddPriceGridForm';
import CarparkPriceGridAddEditForm from 'cpmCarparks/assets/priceGrids/PriceGridAddEditForm';
import CarparkPriceGridAddParkingCategoryForm from 'cpmCarparks/assets/priceGrids/PriceGridAddParkingCategoryForm';
import CarparkPriceGridInfo from 'cpmCarparks/assets/priceGrids/PriceGridInfo';
import CarparkCustomerAddEditForm from 'cpmCarparks/assets/customers/CustomerAddEditForm';
import CarparkCustomerChoose from 'cpmCarparks/assets/customers/CustomerChooseList';
import CarparkBookingInfo from 'cpmCarparks/assets/bookings/BookingInfo';
import CarparkParkingInfo from 'cpmCarparks/assets/parkings/ParkingInfo';
import CarparkParkingAddForm from 'cpmCarparks/assets/parkings/ParkingAddForm';
import CarparkParkingEditForm from 'cpmCarparks/assets/parkings/ParkingEditForm';
import CarparkParkingEditOccupancyForm from 'cpmCarparks/assets/parkings/ParkingEditOccupancyForm';
import CarparkBookingEditOccupancyForm from 'cpmCarparks/assets/bookings/BookingEditOccupancyForm';
import CarparkOnDemandEditOccupancyForm from 'cpmCarparks/assets/onDemand/OnDemandEditOccupancyForm';
import CarparkOnDemandCategorizeForm from 'cpmCarparks/assets/onDemand/OnDemandCategorizeForm';
import CarparkOnDemandEditForm from 'cpmCarparks/assets/onDemand/OnDemandEditForm';
import CarparkOnDemandSendPriceGridForm from 'cpmCarparks/assets/onDemand/OnDemandSendPriceGridForm';
import CarparkOnDemandTerminateForm from 'cpmCarparks/assets/onDemand/OnDemandTerminateForm';
import CarparkOnDemandRefundAll from 'cpmCarparks/assets/onDemand/OnDemandRefundAll';
import CarparkAccessInfo from 'cpmCarparks/assets/accesses/AccessInfo';
import CarparkBookingAddForm from 'cpmCarparks/assets/bookings/BookingAddForm';
import CarparkBookingEditForm from 'cpmCarparks/assets/bookings/BookingEditForm';
import CarparkBookingRefundAll from 'cpmCarparks/assets/bookings/BookingRefundAll';
import CarparkPurchaseRefund from 'cpmCarparks/assets/purchases/PurchaseRefund';
import CarparkOnDemandAddForm from 'cpmCarparks/assets/onDemand/OnDemandAddForm';
import CarparkOnDemandOpenDoor from 'cpmCarparks/assets/onDemand/OnDemandOpenDoor';
import CarparkSettingsIgnoredLicensePlate from 'cpmCarparks/assets/settings/IgnoredLicensePlateForm';
import CarparkChooseList from 'cpmCarparks/assets/main/CarparkChooseList';
import CarparkInvoiceEditForm from 'cpmCarparks/assets/payments/InvoiceEditForm';
import CarparkPartnerChooseList from 'cpmCarparks/assets/settings/CarparkPartnerChooseList';
import PaymentErrorsList from 'cpmCarparks/assets/payments/PaymentErrorsList';

// Partner
import PartnerInfo from 'cpmWorkspaces/assets/partner/PartnerInfo';
import PartnerAddEditForm from 'cpmWorkspaces/assets/partner/PartnerAddEditForm';
// Workspace
import WorkspaceAddEditForm from 'cpmWorkspaces/assets/main/WorkspaceAddEditForm';
import WorkspaceGroupChooseList from 'cpmWorkspaces/assets/workspaceGroup/WorkspaceGroupChooseList';
import WorkspaceGroupAddEdit from 'cpmWorkspaces/assets/workspaceGroup/WorkspaceGroupAddEdit';
import ServiceFeeRuleAddEditForm from 'cpmWorkspaces/assets/serviceFeeRule/ServiceFeeRuleAddEditForm';
import ServiceFeeRuleChooseList from 'cpmWorkspaces/assets/serviceFeeRule/ServiceFeeRuleChooseList';
import SlugAddEditForm from 'cpmWorkspaces/assets/slug/SlugAddEditForm';
import SlugManagement from 'cpmWorkspaces/assets/slug/SlugManagement';

/* eslint-disable quote-props */
const DialogComponents = {
  // Global
  'CONFIRM_MESSAGE': ConfirmMessage,
  'INFO_MESSAGE': InfoMessage,
  'PLANNING_PERIOD_EDIT': PlanningPeriodEditForm,
  // Account
  'PASSWORD_CONFIRMATION': PasswordConfirmationDialog,
  // Installations
  'INSTALLATION_ENTITY_ADD_EDIT': InstallationEntityAddEditForm,
  'INSTALLATION_DEVICE_EDIT': InstallationDeviceEditForm,
  'INSTALLATION_ANTIPASSBACK_DETAILS': InstallationAntipassbackDetails,
  'INSTALLATION_DAILY_CODES_ADD': InstallationDailyCodesAddForm,
  'INSTALLATION_LOG_INFO': InstallationLogInfo,
  'INSTALLATION_ASYNC_OPERATION_HISTORY': InstallationAsyncOperationHistory,
  // Devices
  'DEVICE_SMS_HISTORY': DeviceSmsHistory,
  'DEVICE_LOG_INFO': DeviceLogInfo,
  // Simcards
  'SIMCARD_GROUPS_MANAGER': SimcardGroupsManager,
  // Companies
  'CHOOSE_COMPANY': CompanyChooseList,
  // Profiles
  'PROFILE_PERMISSIONS': ProfilePermissions,
  'USER_PERMISSIONS': UserPermissions,
  'USER_PERMISSION_ADD': UserPermissionAdd,
  // Carparks
  'CARPARK_CONTACT_EDIT': CarparkContactEditForm,
  'CARPARK_DEVICES': CarparkDevices,
  'CARPARK_PLANNING_ADD_EDIT': CarparkPlanningAddEditForm,
  'CARPARK_PLANNING_INFO': CarparkPlanningInfo,
  'CARPARK_SPACES_SETTINGS_EDIT': CarparkSpacesSettingsEditForm,
  'CARPARK_PARKING_CATEGORY_ADD_EDIT': CarparkParkingCategoryAddEditForm,
  'CARPARK_PARKING_CATEGORY_ADD_PRICE_GRID': CarparkParkingCategoryAddPriceGridForm,
  'CARPARK_PRICE_GRID_ADD_EDIT': CarparkPriceGridAddEditForm,
  'CARPARK_PRICE_GRID_ADD_PARKING_CATEGORY': CarparkPriceGridAddParkingCategoryForm,
  'CARPARK_PRICE_GRID_INFO': CarparkPriceGridInfo,
  'CARPARK_CUSTOMER_ADD_EDIT': CarparkCustomerAddEditForm,
  'CARPARK_CUSTOMER_CHOOSE': CarparkCustomerChoose,
  'CARPARK_BOOKING_INFO': CarparkBookingInfo,
  'CARPARK_PARKING_INFO': CarparkParkingInfo,
  'CARPARK_PARKING_ADD': CarparkParkingAddForm,
  'CARPARK_PARKING_EDIT': CarparkParkingEditForm,
  'CARPARK_PARKING_EDIT_OCCUPANCY': CarparkParkingEditOccupancyForm,
  'CARPARK_BOOKING_EDIT_OCCUPANCY': CarparkBookingEditOccupancyForm,
  'CARPARK_BOOKING_ADD': CarparkBookingAddForm,
  'CARPARK_BOOKING_EDIT': CarparkBookingEditForm,
  'CARPARK_BOOKING_REFUND_ALL': CarparkBookingRefundAll,
  'CARPARK_PURCHASE_REFUND': CarparkPurchaseRefund,
  'CARPARK_ON_DEMAND_CATEGORIZE': CarparkOnDemandCategorizeForm,
  'CARPARK_ON_DEMAND_EDIT': CarparkOnDemandEditForm,
  'CARPARK_ON_DEMAND_EDIT_OCCUPANCY': CarparkOnDemandEditOccupancyForm,
  'CARPARK_ON_DEMAND_SEND_PRICE_GRID': CarparkOnDemandSendPriceGridForm,
  'CARPARK_ON_DEMAND_TERMINATE': CarparkOnDemandTerminateForm,
  'CARPARK_ON_DEMAND_REFUND_ALL': CarparkOnDemandRefundAll,
  'CARPARK_ACCESS_INFO': CarparkAccessInfo,
  'CARPARK_ON_DEMAND_ADD': CarparkOnDemandAddForm,
  'CARPARK_ON_DEMAND_OPEN_DOOR': CarparkOnDemandOpenDoor,
  'CARPARK_SETTINGS_IGNORED_LICENSE_PLATE': CarparkSettingsIgnoredLicensePlate,
  'CARPARK_CHOOSE_LIST': CarparkChooseList,
  'CARPARK_INVOICE_UPDATE': CarparkInvoiceEditForm,
  'CARPARK_PARTNER_CHOOSE_LIST': CarparkPartnerChooseList,
  'CARPARK_PAYMENT_ERRORS': PaymentErrorsList,
  // Partner
  'PARTNER_INFO': PartnerInfo,
  'PARTNER_ADD_EDIT_FORM': PartnerAddEditForm,
  // Workspace
  'WORKSPACE_ADD_EDIT': WorkspaceAddEditForm,
  'WORKSPACE_GROUP_ADD_EDIT': WorkspaceGroupAddEdit,
  'WORKSPACE_GROUP_CHOOSE_LIST': WorkspaceGroupChooseList,
  'SERVICE_FEE_RULE_ADD_EDIT': ServiceFeeRuleAddEditForm,
  'SERVICE_FEE_RULE_CHOOSE_LIST': ServiceFeeRuleChooseList,
  'SLUG_ADD_EDIT': SlugAddEditForm,
  'SLUG_MANAGEMENT': SlugManagement,
};
/* eslint-enable quote-props */

const DraggablePaperComponent = (props) => (
  <Draggable handle="#draggable-dialog-title" cancel='[class*="MuiDialogContent-root"]'>
    <MuiPaper {...props} />
  </Draggable>
);

const styles = (theme) => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogCloseButton = withStyles(styles)(({ classes, onClick }) => (
  <MuiIconButton className={classes.closeButton} onClick={onClick}>
    <AppIcon id="btnClose" />
  </MuiIconButton>
));

const DialogActionButtonComponents = {
  validate: ContainedButton,
  cancel: TextButton,
  close: TextButton,
  delete: WarningContainedButton,
};

const DialogActionButton = ({ type, label, onClick }) => {
  const DialogActionButtonComponent = DialogActionButtonComponents[type];

  if (DialogActionButtonComponent) {
    return (
      <DialogActionButtonComponent
        label={<LocalizedMessage id={`button.${label || type}`} />}
        onClick={onClick}
      />
    );
  }
};

DialogActionButton.propTypes = {
  type: PropTypes.string.isRequired,
  label: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

DialogActionButton.defaultProps = {
  label: null,
};

class DialogItem extends React.Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    const { handleDisplayConfirm, dialog: { props: { confirmBeforeExit } } } = this.props;

    if (confirmBeforeExit) {
      handleDisplayConfirm(
        { id: 'confirm.closeFormDialog' },
        () => this.doClose(),
        { confirmLabel: 'confirm' },
      );
    } else {
      this.doClose();
    }
  }

  handleAction(type, preventClosing) {
    // Call component handler according to action type
    let handlerResult = true;
    switch (type) {
      case 'validate':
        if (_has(this.component, 'handleValidate')) {
          handlerResult = this.component.handleValidate();
        }
        break;
      case 'cancel':
        if (_has(this.component, 'handleCancel')) {
          handlerResult = this.component.handleCancel();
        }
        break;
      case 'close':
        if (_has(this.component, 'handleClose')) {
          handlerResult = this.component.handleClose();
        }
        break;
      case 'delete':
        if (_has(this.component, 'handleDelete')) {
          handlerResult = this.component.handleDelete();
        }
        break;
      default:
        break;
    }

    // Now close Dialog if not prevented
    if (!preventClosing && handlerResult) {
      this.doClose();
    }
  }

  // Private
  doClose() {
    const { dialog, onClose } = this.props;
    onClose(dialog);
  }

  render() {
    const { intl, dialog: { open, props } } = this.props;

    const {
      title,
      actions,
      component,
      size,
      dividers,
    } = props || {};

    // Get component
    const DialogComponent = component && DialogComponents[component.type];

    // Show close button
    const withCloseButton = component.type !== 'CONFIRM_MESSAGE';

    // Build title
    let builtTitle = ' ';
    if (title) {
      const { id, values, fixed } = title;
      builtTitle = fixed || intl.formatMessage({ id }, { ...values });
    }

    // Dialog title style
    let dialogTitleStyle = { cursor: 'move' };
    if (withCloseButton) {
      dialogTitleStyle = {
        ...dialogTitleStyle,
        width: 'calc(100% - 48px)',
      };
    }

    return (
      <MuiDialog
        open={open}
        maxWidth={size || 'sm'}
        fullWidth
        PaperComponent={DraggablePaperComponent}
        onClose={this.handleClose}
      >
        {open && (
          <React.Fragment>
            <MuiDialogTitle
              disableTypography
              style={dialogTitleStyle}
              id="draggable-dialog-title"
            >
              <Typography type="dialogTitle">
                {builtTitle}
              </Typography>
              {withCloseButton && (
                <DialogCloseButton onClick={this.handleClose} />
              )}
            </MuiDialogTitle>
            <MuiDialogContent dividers={dividers}>
              <DialogComponent
                onRef={(ref) => { this.component = ref; }}
                {...component.props}
              />
            </MuiDialogContent>
            <MuiDialogActions>
              {actions && _map(actions, ({ type, label, preventClosing }) => (
                <DialogActionButton
                  key={type}
                  type={type}
                  label={label}
                  onClick={() => this.handleAction(type, !!preventClosing)}
                />
              ))}
            </MuiDialogActions>
          </React.Fragment>
        )}
      </MuiDialog>
    );
  }
}

DialogItem.propTypes = {
  intl: PropTypes.object.isRequired,
  dialog: dialogShape.isRequired,
  onClose: PropTypes.func.isRequired,
  handleDisplayConfirm: PropTypes.func.isRequired,
};

module.exports = compose(
  withConfirmDialog,
  injectIntl,
)(DialogItem);



// WEBPACK FOOTER //
// ./components/dialogs/DialogItem.js